// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kZTD","right":"styles_right__2ySwn"};